import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Table,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Select from "react-select";
import { unitTypes } from "../../utils/constants";
import toast from "react-hot-toast";
import { usePopUpWrapper } from "./index";
import { Collapse, CardBody, Card } from "reactstrap";
import { calculatePrice , calculateTotalShipment} from '../../utils/commenController'
function ViewSupportingProductPopUp({
  viewSupportingModal,
  handleShowSupportingProductViewModal,
  updatedProductSupportedData,
  setUpdatedProductSupportedData,
  productCode,
  sectionData,
}) {
  const { pricingPolicy } = usePopUpWrapper();
  const [expandedRows, setExpandedRows] = useState({});
  const [checkBoxAllChecked, setCheckBoxAllChecked] =  useState(false)
  const [
    selectedSupportingProductStatement,
    setSelectedSupportingProductStatement,
  ] = useState({});
  const [distributorOptionDropdownInIsOpen, setDistributorOptionDropdownIsOpen] = useState({});

  const formattedProductSupportedData = useMemo(() => {
    const { name } = sectionData;
    switch (name) {
      case "MAIN_SECTION":
        const { sectionIndex } = sectionData;
        return (
          updatedProductSupportedData?.[sectionIndex]?.products?.[
            productCode
          ] || []
        );
        break;
      case "SUB_SECTION":
        const { subSectionIndex } = sectionData;
        const { index, subIdx } = subSectionIndex;

        return (
          updatedProductSupportedData?.[index]?.[subIdx]?.[productCode] || []
        );
        break;
      case "NO_SECTION":
        return updatedProductSupportedData[productCode];
        break;
    }
    return [];
  }, [
    updatedProductSupportedData,
    sectionData,
    productCode,
  ]);

console.log("formattedProductSupportedData---->", formattedProductSupportedData);


  const handleDistributorSortOptionDropDown =(index)=>{

    setDistributorOptionDropdownIsOpen((prevState) => {
        if(prevState[index]){
          return {}
        }
        return {[index] : true}
    })
  }
  const isThereHaveAnyDistributor = useMemo(() => {
    return formattedProductSupportedData?.some((item) => item.noDistributor);
  }, [formattedProductSupportedData]);

  useEffect(() => {
    if (!viewSupportingModal) {
      setExpandedRows({});
    }
  }, [viewSupportingModal]);

  const handleCheckAllBoxChange = (value) =>{
    try{
      setCheckBoxAllChecked(value)
      const { name } = sectionData;
      switch (name){
        case "MAIN_SECTION":
          const { sectionIndex } = sectionData;
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [sectionIndex]: {
              ...prev[sectionIndex],
              products: {
                ...prev[sectionIndex].products,
                [productCode]: (
                  prev[sectionIndex]?.products?.[productCode] || []
                ).map(
                  (item, idx) =>
                     (
                      { 
                        ...item, 
                        checked: value 
                     }
                    ) 
                      
                ),
              },
            },
          }));
          break;
        case "SUB_SECTION":
          const { subSectionIndex } = sectionData;
          const { index, subIdx } = subSectionIndex;
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              [subIdx]: {
                ...prev[index][subIdx],
                [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                  (item, idx) =>
                    (
                      { 
                        ...item, 
                        checked: value 
                     }
                    ) 
                ),
              },
            },
          }));
          break;
        case "NO_SECTION":
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [productCode]: prev[productCode].map(
              (item, idx) =>
                (
                  { 
                    ...item, 
                    checked: value 
                 }
                ) 
            ),
          }));
          break;
        default:
            console.log('UNKNOWN SECTION');
            break
      }
    }catch(err){
      console.log('err', err);
      
    }
  }
  // Check Box
  const handleCheckboxChange = (productData, itemIndex, value) => {
    try {
      if (productData.isCertificateExpired) {
        toast.error(
          `This product's SABER certificate has expired. Please renew it promptly to ensure compliance.`
        );
        // return
      }
      if (productData.unit_type == "") {
        toast.error(`Unit Type is required.`);
        return;
      }
      // if(productData.quantity==0 || productData.quantity ==''){
      //   toast.error(`Quantity is required.`)
      //   return
      // }
      console.log("productData", productData);

      const { name } = sectionData;
      switch (name) {
        case "MAIN_SECTION":
          const { sectionIndex } = sectionData;
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [sectionIndex]: {
              ...prev[sectionIndex],
              products: {
                ...prev[sectionIndex].products,
                [productCode]: (
                  prev[sectionIndex]?.products?.[productCode] || []
                ).map(
                  (item, idx) =>
                    idx === itemIndex
                      ? { ...item, checked: value } // Update the checked property for the selected item
                      : item // Keep other items unchanged
                ),
              },
            },
          }));
          break;
        case "SUB_SECTION":
          const { subSectionIndex } = sectionData;
          const { index, subIdx } = subSectionIndex;
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              [subIdx]: {
                ...prev[index][subIdx],
                [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                  (item, idx) =>
                    idx === itemIndex
                      ? { ...item, checked: value } // Update the checked property for the selected item
                      : item // Keep other items unchanged
                ),
              },
            },
          }));
          break;
        case "NO_SECTION":
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [productCode]: prev[productCode].map(
              (item, idx) =>
                idx === itemIndex
                  ? { ...item, checked: value } // Update the unit_type for the selected item
                  : item // Keep other items unchanged
            ),
          }));
          break;
        default:
            console.log('UNKNOWN SECTION');
            break
      }
    } catch (err) {}
  };

  // #Unit Type
  const handleChangeUnitType = (itemIndex, value) => {
    try {
      const { name } = sectionData;
      switch (name) {
        case "MAIN_SECTION":
          const { sectionIndex } = sectionData;
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [sectionIndex]: {
              ...prev[sectionIndex],
              products: {
                ...prev[sectionIndex].products,
                [productCode]: (
                  prev[sectionIndex]?.products?.[productCode] || []
                ).map(
                  (item, idx) =>
                    idx === itemIndex
                      ? { ...item, unit_type: value } // Update the checked property for the selected item
                      : item // Keep other items unchanged
                ),
              },
            },
          }));
          break;
        case "SUB_SECTION":
          const { subSectionIndex } = sectionData;
          const { index, subIdx } = subSectionIndex;
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              [subIdx]: {
                ...prev[index][subIdx],
                [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                  (item, idx) =>
                    idx === itemIndex
                      ? { ...item, unit_type: value } // Update the checked property for the selected item
                      : item // Keep other items unchanged
                ),
              },
            },
          }));
          break;
        case "NO_SECTION":
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [productCode]: prev[productCode].map(
              (item, idx) =>
                idx === itemIndex
                  ? { ...item, unit_type: value } // Update the unit_type for the selected item
                  : item // Keep other items unchanged
            ),
          }));
          break;
        default:
            console.log('UNKNOWN SECTION');
            break
      }
    } catch (err) {}
  };
  // # Quantity
  const handleChangeQuantity = (itemIndex, value) => {
    try {
      try {
        const trimmedValue = value.toString().trim();
        const parsedQuantity = parseFloat(trimmedValue) || 0;
        const { name } = sectionData;
        switch (name) {
          case "MAIN_SECTION":
            const { sectionIndex } = sectionData;
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [sectionIndex]: {
                ...prev[sectionIndex],
                products: {
                  ...prev[sectionIndex].products,
                  [productCode]: (
                    prev[sectionIndex]?.products?.[productCode] || []
                  ).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? {
                            ...item,
                            quantity: value,
                            markup_total_price:  (parseFloat(item.distributor_price_with_markup || 0 ) * value).toFixed(2)
                           
                          } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "SUB_SECTION":
            const { subSectionIndex } = sectionData;
            const { index, subIdx } = subSectionIndex;
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [index]: {
                ...prev[index],
                [subIdx]: {
                  ...prev[index][subIdx],
                  [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? {
                            ...item,
                            quantity: value,

                            markup_total_price:  (parseFloat(item.distributor_price_with_markup || 0 ) * value).toFixed(2)
                            
                          } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "NO_SECTION":
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [productCode]: prev[productCode].map(
                (item, idx) =>
                  idx === itemIndex
                    ? {
                        ...item,
                        quantity: value,
                        markup_total_price:  (parseFloat(item.distributor_price_with_markup ) * value).toFixed(2)
                        
                      } // Update the unit_type for the selected item
                    : item // Keep other items unchanged
              ),
            }));
            break;
          default:
              console.log('UNKNOWN SECTION');
              break
        }
      } catch (err) {}
    } catch (err) {}
  };
  // # Markup
  const handleChangeMarkup = (itemIndex, value) => {
    try {
      try {
        const { name } = sectionData;
        switch (name) {
          case "MAIN_SECTION":
            const { sectionIndex } = sectionData;
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [sectionIndex]: {
                ...prev[sectionIndex],
                products: {
                  ...prev[sectionIndex].products,
                  [productCode]: (
                    prev[sectionIndex]?.products?.[productCode] || []
                  ).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? {
                            ...item,
                            standard_markup: value,
                            distributor_price_with_markup:
                              sectionData.pricingPolicy?.type ==
                              pricingPolicy.manufacture_discount.value
                                ? // Case 3 Manufacture Discount
                                  (
                                    parseFloat(
                                      item?.distributor?.gpl_price ||
                                      item?.distributor?.price
                                    ) *
                                    (1 - parseFloat(value || 0) / 100)
                                  ).toFixed(2)
                                : (
                                    parseFloat(
                                      item?.distributor?.gpl_price ||
                                        item?.distributor?.price
                                 
                                    ) *
                                    (1 + parseFloat(value || 0) / 100)
                                  ).toFixed(2),
                            markupFee :calculatePrice('MARKUP_FEE', item.pricingPolicyOption, (item?.distributor?.gpl_price ||
                              item?.distributor?.price), value,''),
                            markup_total_price:
                              sectionData.pricingPolicy?.type ==
                              pricingPolicy.manufacture_discount.value
                                ? // Case 3 Manufacture Discount
                                  (
                                    parseFloat(
                                      (
                                        parseFloat(
                                          item?.distributor?.gpl_price ||
                                          item?.distributor?.price
                                        ) *
                                        (1 - parseFloat(value || 0) / 100)
                                      ).toFixed(2)
                                    ) * parseFloat(item?.quantity || 0)
                                  ).toFixed(2)
                                : (
                                    parseFloat(
                                      (
                                        parseFloat(
                                          item?.distributor?.gpl_price ||
                                          item?.distributor?.price
                                        ) *
                                        (1 + parseFloat(value || 0) / 100)
                                      ).toFixed(2)
                                    ) * parseFloat(item?.quantity || 0)
                                  ).toFixed(2),
                          } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "SUB_SECTION":
            const { subSectionIndex } = sectionData;
            const { index, subIdx } = subSectionIndex;
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [index]: {
                ...prev[index],
                [subIdx]: {
                  ...prev[index][subIdx],
                  [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? {
                            ...item,
                            standard_markup: value,
                            distributor_price_with_markup:
                              sectionData.pricingPolicy?.type ==
                              pricingPolicy.manufacture_discount.value
                                ? // Case 3 Manufacture Discount
                                  (
                                    parseFloat(
                                      item?.distributor?.gpl_price ||
                                        item?.distributor?.price
                                    ) *
                                    (1 - parseFloat(value || 0) / 100)
                                  ).toFixed(2)
                                : (
                                    parseFloat(
                                      item?.distributor?.gpl_price ||
                                        item?.distributor?.price
                                    ) *
                                    (1 + parseFloat(value || 0) / 100)
                                  ).toFixed(2),
                            markupFee :calculatePrice('MARKUP_FEE', item.pricingPolicyOption, (item?.distributor?.gpl_price ||
                                    item?.distributor?.price), value,''),
                            markup_total_price:
                              sectionData.pricingPolicy?.type ==
                              pricingPolicy.manufacture_discount.value
                                ? // Case 3 Manufacture Discount
                                  (
                                    parseFloat(
                                      (
                                        parseFloat(
                                          item?.distributor?.gpl_price ||
                                            item?.distributor?.price
                                        ) *
                                        (1 - parseFloat(value || 0) / 100)
                                      ).toFixed(2)
                                    ) * parseFloat(item?.quantity || 0)
                                  ).toFixed(2)
                                : (
                                    parseFloat(
                                      (
                                        parseFloat(
                                          item?.distributor?.gpl_price ||
                                            item?.distributor?.price
                                        ) *
                                        (1 + parseFloat(value || 0) / 100)
                                      ).toFixed(2)
                                    ) * parseFloat(item?.quantity || 0)
                                  ).toFixed(2),
                          } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "NO_SECTION":
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [productCode]: prev[productCode].map(
                (item, idx) =>
                  idx === itemIndex
                    ? {
                        ...item,
                        standard_markup: value,

                        distributor_price_with_markup:
                          sectionData.pricingPolicy?.type ==
                          pricingPolicy.manufacture_discount.value
                            ? // Case 3 Manufacture Discount
                              (
                                parseFloat(
                                  item?.distributor?.gpl_price ||
                                    item?.distributor?.price
                                ) *
                                (1 - parseFloat(value || 0) / 100)
                              ).toFixed(2)
                            : (
                                parseFloat(
                                  item?.distributor?.gpl_price ||
                                    item?.distributor?.price
                                ) *
                                (1 + parseFloat(value || 0) / 100)
                              ).toFixed(2),
                        markupFee :calculatePrice('MARKUP_FEE', item.pricingPolicyOption, (item?.distributor?.gpl_price ||
                                item?.distributor?.price), value,''),
                        markup_total_price:
                          sectionData.pricingPolicy?.type ==
                          pricingPolicy.manufacture_discount.value
                            ? // Case 3 Manufacture Discount
                              (
                                parseFloat(
                                  (
                                    parseFloat(
                                      item?.distributor?.gpl_price ||
                                        item?.distributor?.price
                                    ) *
                                    (1 - parseFloat(value || 0) / 100)
                                  ).toFixed(2)
                                ) * parseFloat(item?.quantity || 0)
                              ).toFixed(2)
                            : (
                                parseFloat(
                                  (
                                    parseFloat(
                                      item?.distributor?.gpl_price ||
                                        item?.distributor?.price
                                    ) *
                                    (1 + parseFloat(value || 0) / 100)
                                  ).toFixed(2)
                                ) * parseFloat(item?.quantity || 0)
                              ).toFixed(2),
                      } // Update the unit_type for the selected item
                    : item // Keep other items unchanged
              ),
            }));
            break;
          default:
              console.log('UNKNOWN SECTION');
              break
        }
      } catch (err) {}
    } catch (err) {}
  };
  // # Distributor
  const handleDistributorSelectChange = (selectedOption, itemIndex) => {
    try {
      try {
        console.log("selectedOptionselectedOption", selectedOption);
        
        
        
        const { name } = sectionData;
        switch (name) {
          case "MAIN_SECTION":
            const { sectionIndex } = sectionData;
            
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [sectionIndex]: {
                ...prev[sectionIndex],
                products: {
                  ...prev[sectionIndex].products,
                  [productCode]: (
                    prev[sectionIndex]?.products?.[productCode] || []
                  ).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? {
                            ...item,
                            distributor: selectedOption,
                            distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', item.pricingPolicyOption, (selectedOption?.gpl_price || selectedOption?.price),item.standard_markup,''),
                            markupFee : calculatePrice('MARKUP_FEE', item.pricingPolicyOption, (selectedOption?.gpl_price || selectedOption?.price), item.standard_markup,''),
                            markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', item.pricingPolicyOption, (selectedOption?.gpl_price || selectedOption?.price) ,item.standard_markup,item.quantity),
                            shipmentCharge :   calculateTotalShipment((selectedOption.noDistributor ?  selectedOption.initial_gpl_price : selectedOption.initial_price), selectedOption.logistics?.logistic_fee, selectedOption.logistics?.custom_fee, selectedOption.logistics?.logistic_buffer_charge),
                            // Price with markup=P+(P×M)
                          } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "SUB_SECTION":
            const { subSectionIndex } = sectionData;
            const { index, subIdx } = subSectionIndex;
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [index]: {
                ...prev[index],
                [subIdx]: {
                  ...prev[index][subIdx],
                  [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? {
                            ...item,
                            distributor: selectedOption,
                            distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', item.pricingPolicyOption, (selectedOption?.gpl_price || selectedOption?.price),item.standard_markup,''),
                            markupFee : calculatePrice('MARKUP_FEE', item.pricingPolicyOption, (selectedOption?.gpl_price || selectedOption?.price), item.standard_markup,''),
                            markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', item.pricingPolicyOption, (selectedOption?.gpl_price || selectedOption?.price) ,item.standard_markup,item.quantity),
                            shipmentCharge :   calculateTotalShipment((selectedOption.noDistributor ?  selectedOption.initial_gpl_price : selectedOption.initial_price), selectedOption.logistics.logistic_fee, selectedOption.logistics.custom_fee, selectedOption.logistics.logistic_buffer_charge),
                          } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "NO_SECTION":
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [productCode]: prev[productCode].map(
                (item, idx) =>
                  idx === itemIndex
                    ? {
                        ...item,
                        distributor: selectedOption,
                        distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', item.pricingPolicyOption, (selectedOption?.gpl_price || selectedOption?.price),item.standard_markup,''),
                        markupFee : calculatePrice('MARKUP_FEE', item.pricingPolicyOption, (selectedOption?.gpl_price || selectedOption?.price), item.standard_markup,''),
                        markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', item.pricingPolicyOption, (selectedOption?.gpl_price || selectedOption?.price) ,item.standard_markup,item.quantity),
                        shipmentCharge :   calculateTotalShipment((selectedOption.noDistributor ?  selectedOption.initial_gpl_price : selectedOption.initial_price), selectedOption.logistics.logistic_fee, selectedOption.logistics.custom_fee, selectedOption.logistics.logistic_buffer_charge),
                      } // Update the unit_type for the selected item
                    : item // Keep other items unchanged
              ),
            }));
            break;
          default:
              console.log('UNKNOWN SECTION');
              break
        }
      } catch (err) {}
    } catch (err) {}
  };
  // # Discount
  const handleDiscountChange = (itemIndex, value) => {
    try {
      const { name } = sectionData;
      switch (name) {
        case "MAIN_SECTION":
          const { sectionIndex } = sectionData;
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [sectionIndex]: {
              ...prev[sectionIndex],
              products: {
                ...prev[sectionIndex].products,
                [productCode]: (
                  prev[sectionIndex]?.products?.[productCode] || []
                ).map(
                  (item, idx) =>
                    idx === itemIndex
                      ? { ...item, discount_value: value } //  Update the Discount for the selected item
                      : item // Keep other items unchanged
                ),
              },
            },
          }));
          break;
        case "SUB_SECTION":
          const { subSectionIndex } = sectionData;
          const { index, subIdx } = subSectionIndex;
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [index]: {
              ...prev[index],
              [subIdx]: {
                ...prev[index][subIdx],
                [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                  (item, idx) =>
                    idx === itemIndex
                      ? { ...item, discount_value: value } //  Update the Discount for the selected item
                      : item // Keep other items unchanged
                ),
              },
            },
          }));
          break;
        case "NO_SECTION":
          setUpdatedProductSupportedData((prev) => ({
            ...prev,
            [productCode]: prev[productCode].map(
              (item, idx) =>
                idx === itemIndex
                  ? { ...item, discount_value: value } // Update the Discount for the selected item
                  : item // Keep other items unchanged
            ),
          }));
          break;
        default:
            console.log('UNKNOWN SECTION');
            break
      }
    } catch (err) {}
  };
  // #Total price
  const handleChangeTotalPrice = (itemIndex, value) => {
    try {
      const trimmedValue = value.toString().trim();
      try {
        const { name } = sectionData;
        switch (name) {
          case "MAIN_SECTION":
            const { sectionIndex } = sectionData;
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [sectionIndex]: {
                ...prev[sectionIndex],
                products: {
                  ...prev[sectionIndex].products,
                  [productCode]: (
                    prev[sectionIndex]?.products?.[productCode] || []
                  ).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? { ...item, markup_total_price: trimmedValue } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "SUB_SECTION":
            const { subSectionIndex } = sectionData;
            const { index, subIdx } = subSectionIndex;
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [index]: {
                ...prev[index],
                [subIdx]: {
                  ...prev[index][subIdx],
                  [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? { ...item, markup_total_price: trimmedValue } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "NO_SECTION":
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [productCode]: prev[productCode].map(
                (item, idx) =>
                  idx === itemIndex
                    ? { ...item, markup_total_price: trimmedValue } // Update the unit_type for the selected item
                    : item // Keep other items unchanged
              ),
            }));
            break;
          default:
              console.log('UNKNOWN SECTION');
              break
        }
      } catch (err) {}
      // setUpdatedProductSupportedData((prev) => (
      // {
      //   ...prev,
      //   [productCode] : prev[productId].map((item,idx)=>(
      //     idx === index
      //       ? {
      //         ...item,
      //         markup_total_price : trimmedValue
      //        }
      //       : item
      //   ))
      // }
      // ));
    } catch (err) {}
  };
  // #Distributor price  change
  const handleChangeDistributorPrice = (itemIndex, value) => {
    try {
      const trimmedValue = value.toString().trim();
      try {
        const { name } = sectionData;
        switch (name) {
          case "MAIN_SECTION":
            const { sectionIndex } = sectionData;
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [sectionIndex]: {
                ...prev[sectionIndex],
                products: {
                  ...prev[sectionIndex].products,
                  [productCode]: (
                    prev[sectionIndex]?.products?.[productCode] || []
                  ).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? { ...item, 
                          distributor_price_with_markup : trimmedValue,
                          markup_total_price : trimmedValue * item.quantity,
                          standard_markup : '0',
                          markupFee : '0'
                         } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "SUB_SECTION":
            const { subSectionIndex } = sectionData;
            const { index, subIdx } = subSectionIndex;
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [index]: {
                ...prev[index],
                [subIdx]: {
                  ...prev[index][subIdx],
                  [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                    (item, idx) =>
                      idx === itemIndex
                        ? { ...item, distributor_price_with_markup: trimmedValue,
                          markup_total_price : trimmedValue * item.quantity,
                          standard_markup : '0',
                          markupFee : '0'
                         } // Update the checked property for the selected item
                        : item // Keep other items unchanged
                  ),
                },
              },
            }));
            break;
          case "NO_SECTION":
            setUpdatedProductSupportedData((prev) => ({
              ...prev,
              [productCode]: prev[productCode].map(
                (item, idx) =>
                  idx === itemIndex
                    ? { ...item, distributor_price_with_markup: trimmedValue,
                      markup_total_price : trimmedValue * item.quantity,
                      standard_markup : '0',
                      markupFee : '0'
                     } // Update the unit_type for the selected item
                    : item // Keep other items unchanged
              ),
            }));
            break;
          default:
              console.log('UNKNOWN SECTION');
              break
        }
      } catch (err) {}
      // setUpdatedProductSupportedData((prev) => (
      // {
      //   ...prev,
      //   [productCode] : prev[productId].map((item,idx)=>(
      //     idx === index
      //       ? {
      //         ...item,
      //         markup_total_price : trimmedValue
      //        }
      //       : item
      //   ))
      // }
      // ));
    } catch (err) {}
  };

  const handleShowSupportingProductViewStatementModal = (rowIndex, item) => {
    try {
      setExpandedRows((prevState) => {
        // If the clicked row is already expanded, collapse it
        if (prevState[rowIndex]) {
          return {}; // Collapse all rows
        }
        // Otherwise, expand the clicked row and collapse others
        return { [rowIndex]: true };
      });

      const basePrice = parseFloat(
        item.distributor.gpl_price || item.distributor.price || 0
      );
      const discountValue = parseFloat(item.discount_value || 0);

      const vendorUnitCost =
        sectionData.pricingPolicy?.type ==
          pricingPolicy.standard_pricing.value ||
        sectionData.pricingPolicy?.type ==
          pricingPolicy.distributor_discount.value ||
        sectionData.pricingPolicy?.type ==
          pricingPolicy.manufacture_discount.value
          ? basePrice > 0
            ? sectionData.pricingPolicy?.type ==
                pricingPolicy.distributor_discount.value ||
              sectionData.pricingPolicy?.type ==
                pricingPolicy.manufacture_discount.value
              ? basePrice - basePrice * (discountValue / 100)
              : basePrice // Fallback to basePrice if not a specific discount type
            : "0"
          : "0";
      const vendorTotalCost = vendorUnitCost * item.quantity;

      const vendorTotalProfit =
        parseFloat(item.markup_total_price) - parseFloat(vendorTotalCost);
      const formattedData = {
        unit_type: item.unit_type,
        quantity: item.quantity,
        u_cost: item.distributor.gpl_price
          ? item.distributor.gpl_price
          : item.distributor.price,
        t_cost: (
          parseFloat(
            item.distributor.gpl_price
              ? item.distributor.gpl_price
              : item.distributor.price
          ) * parseFloat(item.quantity)
        ).toFixed(2),
        standard_markup: item.standard_markup,
        u_price: item.distributor_price_with_markup,
        t_price: item.markup_total_price,
        v_discount: item.discount_value || "",
        v_unit_cost: parseFloat(vendorUnitCost)?.toFixed(2),
        v_total_cost: vendorTotalCost.toFixed(2),
        v_total_profit: vendorTotalProfit.toFixed(2),
      };
      setSelectedSupportingProductStatement(formattedData);
    } catch (error) {}
  };



  
  const handleDistributorSortOption = (itemIndex, value)=>{
    const { name } = sectionData;

    
    switch(name){
      case "MAIN_SECTION":
      const { sectionIndex } = sectionData;
         // Deep copy arrays to avoid mutating original state directly

      let distributorOptionsInMainSection = [...updatedProductSupportedData[sectionIndex].products[productCode][itemIndex].distributorOptions].sort((a, b) => 
          parseFloat(value === 'PRICE' ? a.initial_price : a.lead_time) - 
          parseFloat(value === 'PRICE' ? b.initial_price : b.lead_time)
      );

      
      const basePriceInMainSection = distributorOptionsInMainSection?.[0].gpl_price || distributorOptionsInMainSection?.[0].price

      
        setUpdatedProductSupportedData((prev) => ({
          ...prev,
          [sectionIndex]: {
            ...prev[sectionIndex],
            products: {
              ...prev[sectionIndex].products,
              [productCode]: (
                prev[sectionIndex]?.products?.[productCode] || []
              ).map(
                (item, idx) =>
                  idx === itemIndex
                    ? { ...item, 
                      distributorOptions: distributorOptionsInMainSection,
                      selectedSortOption : value,
                      distributor: distributorOptionsInMainSection?.[0] || {}, 
                      distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', item.pricingPolicyOption, basePriceInMainSection,item.standard_markup,''),
                      markupFee :calculatePrice('MARKUP_FEE', item.pricingPolicyOption, basePriceInMainSection,item.standard_markup,''),
                      markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', item.pricingPolicyOption, basePriceInMainSection ,item.standard_markup,item.quantity),
                      shipmentCharge :   calculateTotalShipment((distributorOptionsInMainSection?.[0]?.noDistributor ?  distributorOptionsInMainSection?.[0]?.initial_gpl_price : distributorOptionsInMainSection?.[0]?.initial_price), distributorOptionsInMainSection[0].logistics.logistic_fee, distributorOptionsInMainSection[0].logistics.custom_fee, distributorOptionsInMainSection[0].logistics.logistic_buffer_charge),
                    } // Update the checked property for the selected item
                    : item // Keep other items unchanged
              ),
            },
          },
        }));
        break;
      case "SUB_SECTION":
        const { subSectionIndex } = sectionData;
        const { index, subIdx } = subSectionIndex;
        let distributorOptionsInSubSection = [...updatedProductSupportedData[index][subIdx][productCode][itemIndex].distributorOptions].sort((a, b) => 
          parseFloat(value === 'PRICE' ? a.initial_price : a.lead_time) - 
          parseFloat(value === 'PRICE' ? b.initial_price : b.lead_time)
      );

      
      const basePriceInSubSection = distributorOptionsInSubSection?.[0].gpl_price || distributorOptionsInSubSection?.[0].price
        setUpdatedProductSupportedData((prev) => ({
          ...prev,
          [index]: {
            ...prev[index],
            [subIdx]: {
              ...prev[index][subIdx],
              [productCode]: (prev[index][subIdx]?.[productCode] || []).map(
                (item, idx) =>
                  idx === itemIndex
                    ? { ...item, 
                      distributorOptions: distributorOptionsInSubSection,
                      selectedSortOption : value,
                      distributor: distributorOptionsInSubSection?.[0] || {}, 
                      distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', item.pricingPolicyOption, basePriceInSubSection,item.standard_markup,''),
                      markupFee :calculatePrice('MARKUP_FEE', item.pricingPolicyOption, basePriceInSubSection,item.standard_markup,''),
                      markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', item.pricingPolicyOption, basePriceInSubSection ,item.standard_markup,item.quantity),
                      shipmentCharge :   calculateTotalShipment((distributorOptionsInSubSection?.[0]?.noDistributor ?  distributorOptionsInSubSection?.[0]?.initial_gpl_price : distributorOptionsInSubSection?.[0]?.initial_price), distributorOptionsInSubSection[0].logistics.logistic_fee, distributorOptionsInSubSection[0].logistics.custom_fee, distributorOptionsInSubSection[0].logistics.logistic_buffer_charge),
                    } // Update the checked property for the selected item
                    : item // Keep other items unchanged
              ),
            },
          },
        }));
        break;
      case "NO_SECTION":

        // Deep copy arrays to avoid mutating original state directly

        let distributorOptionsInNoSection = [...updatedProductSupportedData[productCode][itemIndex].distributorOptions].sort((a, b) => 
            parseFloat(value === 'PRICE' ? a.initial_price : a.lead_time) - 
            parseFloat(value === 'PRICE' ? b.initial_price : b.lead_time)
        );

     
     const basePriceInNoSection = distributorOptionsInNoSection?.[0].gpl_price || distributorOptionsInNoSection?.[0].price
        setUpdatedProductSupportedData((prev) => ({
          ...prev,
          [productCode]: prev[productCode].map(
            (item, idx) =>
              idx === itemIndex
                ? { ...item,
                    distributorOptions: distributorOptionsInNoSection,
                    selectedSortOption : value,
                    distributor: distributorOptionsInNoSection?.[0] || {}, 
                    distributor_price_with_markup : calculatePrice('DISTRIBUTOR_PRICE_WITH_MARKUP', item.pricingPolicyOption, basePriceInNoSection,item.standard_markup,''),
                    markupFee :calculatePrice('MARKUP_FEE', item.pricingPolicyOption, basePriceInNoSection,item.standard_markup,''),
                    markup_total_price :  calculatePrice('MARKUP_TOTAL_PRICE', item.pricingPolicyOption, basePriceInNoSection ,item.standard_markup,item.quantity),
                    shipmentCharge :   calculateTotalShipment((distributorOptionsInNoSection?.[0]?.noDistributor ?  distributorOptionsInNoSection?.[0]?.initial_gpl_price : distributorOptionsInNoSection?.[0]?.initial_price), distributorOptionsInNoSection[0].logistics.logistic_fee, distributorOptionsInNoSection[0].logistics.custom_fee, distributorOptionsInNoSection[0].logistics.logistic_buffer_charge),
                  } // Update the unit_type for the selected item
                : item // Keep other items unchanged
          ),
        }));
        break;
      default:
        console.error("No section available");
        break;
        
    }
  }

  const tableColumnCount = useMemo(() => {
    let columnCount = 10;
    if (isThereHaveAnyDistributor) {
      columnCount = columnCount + 1;
    }
    if (
      sectionData.pricingPolicy?.type ==
        pricingPolicy.distributor_discount.value ||
      sectionData.pricingPolicy?.type ==
        pricingPolicy.manufacture_discount.value
    ) {
      columnCount = columnCount + 1;
    }
    return columnCount;
  }, [isThereHaveAnyDistributor, sectionData]);

  return (
    <Modal
      size="xl"
      fullscreen={true}
      contentClassName="custom-modal-content"
      isOpen={viewSupportingModal}
      toggle={handleShowSupportingProductViewModal}
    >
      <ModalHeader toggle={handleShowSupportingProductViewModal}></ModalHeader>
      <ModalBody>
      <div className="table-responsive">
        <Table bordered>
          <thead>
            <tr>
            {/* <th style={{ width: '5%' }}></th> */}
            <th  >
              <FormGroup check>
                <br />
                <Input
                  style={{ fontSize: "larger" }}
                  type="checkbox"
                  checked={checkBoxAllChecked}
                  onChange={(e) =>
                    handleCheckAllBoxChange(
                      e.target.checked
                    )
                  }
                />
              </FormGroup>
            </th>
            <th style={{ whiteSpace: 'nowrap' }}>Product Name</th>
            <th style={{ whiteSpace: 'nowrap' }}>Unit Type</th>
            <th style={{ whiteSpace: 'nowrap' }}>Quantity</th>
            <th style={{ whiteSpace: 'nowrap' }}>GPL</th>
            {/* {isThereHaveAnyDistributor && (
              <th style={{ whiteSpace: 'nowrap', width: '12%' }}>Manufacture Price</th>
            )} */}
            <th style={{ whiteSpace: 'nowrap' }}>Distributor</th>
            <th style={{ whiteSpace: 'nowrap' }}>U.Price</th>
            <th style={{ whiteSpace: 'nowrap' }}>Standard Markup (%)</th>
            {(sectionData.pricingPolicy?.type === pricingPolicy.distributor_discount.value ||
              sectionData.pricingPolicy?.type === pricingPolicy.manufacture_discount.value) && (
              <th>Discount (%)</th>
            )}
            <th style={{ whiteSpace: 'nowrap' }}>Total Final Amount</th>
            {/* <th style={{ width: '10%' }}></th> */}
            </tr>
          </thead>
          <tbody>
            {formattedProductSupportedData?.map((spItem, spIndex) => (
              <>
                <tr key={spIndex}>
                  <td className="text-center" >
                    <FormGroup check>
                      <br />
                      <Input
                        style={{ fontSize: "larger" }}
                        type="checkbox"
                        checked={spItem.checked}
                        onChange={(e) =>
                          handleCheckboxChange(
                            spItem,
                            spIndex,
                            e.target.checked
                          )
                        }
                      />
                    </FormGroup>
                  </td>
                  <td >
                    <br />
                    <span style={{ fontWeight: "bold" }}>
                      {spItem?.product.name}
                    </span>
                  </td>
                  <td>
                    <FormGroup>
                      <br />
                      <div style={{ width : 'max-content'}}>
                      <Input
                        type="select"
                        name="unit_type"
                        defaultValue={"Ea"}
                        id="unit_type"
                        value={spItem.unit_type}
                        onChange={(e) =>
                          handleChangeUnitType(spIndex, e.target.value)
                        }
                        className="selectInput me-2"
                        >
                        <option value="">Select type</option>
                        {unitTypes.map((item, idx) => (
                          <option key={idx} value={item.value}>
                            {item.name}
                          </option>
                        ))}
                        </Input>
                      </div>
   
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <br />
                      <Input
                        type="number"
                        value={spItem.quantity}
                        onChange={(e) =>
                          handleChangeQuantity(spIndex, e.target.value)
                        }
                        id="quantity"
                        name="quantity"
                      />
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <br />
                      <Input
                        value={spItem.initial_gpl_price}
                        type="text"
                        readOnly
                      />
                    </FormGroup>
                  </td>
                  {/* {isThereHaveAnyDistributor && (
                    <td>
                      {spItem.noDistributor && (
                        <FormGroup>
                          <Label style={{ whiteSpace: "nowrap" }}>
                            (includes Logistic Fee:{" "}
                            <span style={{ color: "red" }}>
                              {spItem?.shipmentCharge || "0.00"}
                            </span>
                            , Markup Fee:{" "}
                            <span style={{ color: "red" }}>
                              {spItem?.markupFee || "0.00"}
                            </span>
                            )
                          </Label>
                          <Input
                            value={spItem.distributor_price_with_markup}
                            type="text"
                            readOnly
                          />
                        </FormGroup>
                      )}
                    </td>
                  )} */}

                  {/* Distributor price without markup */}
                  <td style={{whiteSpace: 'nowrap'}}>
                    <FormGroup>
                      <br />
                      <div className="d-flex">
                       <div style={{flexGrow : '1', width : 'max-content'}} className="me-2">
                      <Select
                        options={spItem.distributorOptions}
                        placeholder="Select a distributor"
                        style={{ whiteSpace: "nowrap", width : '20%' }}
                        value={spItem.distributor}
       
                        isSearchable
                        onChange={(selectedOption) =>
                          handleDistributorSelectChange(selectedOption, spIndex)
                        }
                        menuPortalTarget={document.body} // Render menu to the body
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Prevent overlapping issues
                        }}
                      />
                     </div>
                     {!spItem?.noDistributor && <div className="d-flex align-items-center">
                        <Dropdown isOpen={distributorOptionDropdownInIsOpen[spIndex]} toggle={() =>handleDistributorSortOptionDropDown(spIndex)} direction="down">
                          <DropdownToggle
                            caret
                            style={{
                              backgroundColor: "transparent",
                              border: "none",
                              boxShadow: "none",
                              padding: "0px",
                            }}
                          >
                            <i
                              style={{ fontSize: "x-large", color: "black" }}
                              className="bi bi-filter-circle"
                            ></i>
                          </DropdownToggle>
                          <DropdownMenu
                            style={{
                              border: "none",
                              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                              right: 0, // Forces alignment to the left of the button
                            }}
                          >
                            <DropdownItem  
                            onClick={()=>handleDistributorSortOption( spIndex,'PRICE')} style={{ 
                              padding: "10px 20px", 
                              cursor: "pointer", 
                              background: spItem?.selectedSortOption === 'PRICE' ? "antiquewhite" : ""
                            }}>
                              Price
                            </DropdownItem>
                            <DropdownItem 
                              onClick={()=>handleDistributorSortOption( spIndex,'LEAD_TIME')} style={{ 
                                padding: "10px 20px", 
                                cursor: "pointer", 
                                background: spItem?.selectedSortOption === 'LEAD_TIME' ? "antiquewhite" : ""
                              }}>
                              Lead time
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                    </div>}
                     </div>

                    </FormGroup>
                  </td>
                  {/* Distributor price with markup */}
                    <td>
                      {/* {!spItem.noDistributor && ( */}
                        <FormGroup>
                          <Label style={{ whiteSpace: "nowrap" }}>
                            (includes Logistic Fee:{" "}
                            <span style={{ color: "red" }}>
                              {spItem?.shipmentCharge || "0.00"}
                            </span>
                            , Markup Fee:{" "}
                            <span style={{ color: "red" }}>
                              {spItem?.markupFee || "0.00"}
                            </span>
                            )
                          </Label>
                          <Input
                            type="number"
                            value={spItem.distributor_price_with_markup}
                            onChange={(e) =>
                              handleChangeDistributorPrice(spIndex, e.target.value)
                            }
                          />
                        </FormGroup>
                      {/* )} */}
                    </td>
                  {/* Markup */}
                  <td >
                    <FormGroup>
                      <br />
                      <Input
                        type="text"
                        value={spItem.standard_markup}
                        onChange={(e) =>
                          handleChangeMarkup(spIndex, e.target.value)
                        }
                        id="standard_markup"
                        name="standard_markup"
                      />
                    </FormGroup>
                  </td>
                  {/* Discount */}
                  {(sectionData.pricingPolicy?.type ==
                    pricingPolicy.distributor_discount.value ||
                    sectionData.pricingPolicy?.type ==
                      pricingPolicy.manufacture_discount.value) && (
                    <td>
                      <br />
                      {!(spItem.distributor.value == '' && spItem.pricingPolicy == pricingPolicy.distributor_discount.value) &&<Input
                        type="number"
                        // readOnly={spItem.distributor.value == '' && spItem.pricingPolicy == pricingPolicy.distributor_discount.value }
                        value={spItem.discount_value || ""}
                        onChange={(e) =>
                          handleDiscountChange(spIndex, e.target.value)
                        }
                      />}
                    </td>
                  )}
                  <td > 
                    <FormGroup>
                      <br />
                      <Input
                        type="text"
                        value={spItem.markup_total_price}
                        onChange={(e) =>
                          handleChangeTotalPrice(spIndex, e.target.value)
                        }
                        id="final_amount"
                        name="final_amount"
                      />
                    </FormGroup>
                  </td>
                  <td >
                    <br />
                    <div className="d-flex justify-content-center align-items-center">
                      <Button
                        color="info"
                        onClick={(e) =>
                          handleShowSupportingProductViewStatementModal(
                            spIndex,
                            spItem
                          )
                        }
                      >
                        View Statement
                      </Button>
                    </div>
                  </td>
                </tr>
                {expandedRows[spIndex] && (
                  <tr>
                    <td colSpan={tableColumnCount}>
                      <Collapse isOpen={expandedRows[spIndex]}>
                        <div style={{ padding: "15px", background: "#f9f9f9" }}>
                          <Table size="xl" striped bordered>
                            <thead>
                              <tr className="table-secondary text-center">
                                <th>Unit type</th>
                                <th>Quantity</th>
                                <th>U.Cost</th>
                                <th>T.Cost</th>
                                <th>Markup(%)</th>
                                <th>U.Price</th>
                                <th>T.Price</th>
                                <th>Discount</th>
                                <th>U.Price (Vendor)</th>
                                <th>T.Price (Vendor)</th>
                                <th>Total Profit</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="table-primary text-center">
                                <td>
                                  {selectedSupportingProductStatement.unit_type}
                                </td>
                                <td>
                                  {selectedSupportingProductStatement.quantity}
                                </td>
                                <td>
                                  {selectedSupportingProductStatement.u_cost}
                                </td>
                                <td>
                                  {selectedSupportingProductStatement.t_cost}
                                </td>
                                <td>
                                  {parseFloat(
                                    selectedSupportingProductStatement.standard_markup || 0
                                  ).toString()}{" "}
                                  %
                                </td>
                                <td>
                                  {selectedSupportingProductStatement.u_price}
                                </td>
                                <td>
                                  {selectedSupportingProductStatement.t_price}
                                </td>
                                <td>
                                  {parseFloat(
                                    selectedSupportingProductStatement.v_discount
                                  )
                                    ? `${parseFloat(
                                        selectedSupportingProductStatement.v_discount
                                      )} %`
                                    : ""}
                                </td>
                                <td>
                                  {
                                    selectedSupportingProductStatement.v_unit_cost
                                  }
                                </td>
                                <td>
                                  {
                                    selectedSupportingProductStatement.v_total_cost
                                  }
                                </td>
                                <td>
                                  {
                                    selectedSupportingProductStatement.v_total_profit
                                  }
                                </td>
                              </tr>
                            </tbody>
                          </Table>
                        </div>
                      </Collapse>
                    </td>
                  </tr>
                )}
              </>
            ))}
          </tbody>
        </Table>
        </div>
      </ModalBody>
    </Modal>
  );
}

ViewSupportingProductPopUp.propTypes = {
  viewSupportingModal: PropTypes.bool.isRequired,
  handleShowSupportingProductViewModal: PropTypes.func.isRequired,
  distributorOptions: PropTypes.array,
};

export default ViewSupportingProductPopUp;
